import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { CreateRelationPayload } from '@rossum/api-client/relations';
import { api } from '../../../../lib/apiClient';
import { throwError } from '../../../../redux/modules/messages/actions';
import { ATTACHMENTS_RELATIONS_QUERY_KEY } from './useFetchAttachmentRelation';

const ADD_ATTACHMENTS_MUTATION_KEY = 'add-attachments';

export const useCreateAttachments = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ADD_ATTACHMENTS_MUTATION_KEY],

    mutationFn: (payload: CreateRelationPayload) =>
      api.request(endpoints.relations.create(payload)),

    onError: () => {
      dispatch(throwError('createAttachmentError'));
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ATTACHMENTS_RELATIONS_QUERY_KEY],
      });
    },
  });
};
